import { BasePill } from "./BasePill";
import { PillProps } from "./types";

export const SuccessPill = ({
  children,
  variant = "DEFAULT",
  ...props
}: PillProps) => {
  return (
    <BasePill {...props} type="SUCCESS" variant={variant}>
      {children}
    </BasePill>
  );
};
